var _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrunei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.989 511.989",
    viewBox: "0 0 511.989 511.989",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.997,
    cy: 255.996,
    fill: "#f0f0f0",
    r: 255.957
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.33 128.016c-11.553 20.008-20.075 40.926-25.75 62.233l428.058 247.141c15.615-15.569 29.471-33.41 41.021-53.417z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m383.974 34.329c-102.416-59.129-228.696-39.422-308.623 40.27l428.058 247.139c29.053-109.062-17.021-228.279-119.435-287.409z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.017 477.66c102.414 59.129 228.697 39.422 308.622-40.269l-428.059-247.142c-29.051 109.065 17.021 228.282 119.437 287.411z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328.331 228.173c0 39.949-32.386 72.336-72.336 72.336s-72.336-32.386-72.336-72.336c0-12.456 3.149-24.177 8.695-34.41-15.697 16.053-25.388 38.005-25.388 62.231 0 49.169 39.859 89.029 89.029 89.029s89.029-39.859 89.029-89.029c0-24.226-9.69-46.178-25.388-62.231 5.546 10.235 8.695 21.954 8.695 34.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.304 144.71h33.386v166.929h-33.386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.638 178.095h-111.285c0 7.683 6.693 13.911 14.375 13.911h-.464c0 7.683 6.229 13.911 13.911 13.911 0 7.683 6.229 13.911 13.911 13.911h27.821c7.683 0 13.911-6.228 13.911-13.911 7.683 0 13.911-6.228 13.911-13.911h-.463c7.68-.001 14.372-6.227 14.372-13.911z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.097 322.767h155.8v33.386h-155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.382 333.896h66.771v33.386h-66.771z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.84 333.896h66.771v33.386h-66.771z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrunei);
export default __webpack_public_path__ + "static/media/brunei.c7d8b6d9fbf6a157475ceb67823ed573.svg";
export { ForwardRef as ReactComponent };